import { render, staticRenderFns } from "./AddTransferStoreFormModal.vue?vue&type=template&id=84036e50&"
import script from "./AddTransferStoreFormModal.vue?vue&type=script&lang=js&"
export * from "./AddTransferStoreFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports